import { Component, Emit, Vue } from 'vue-property-decorator';
import { DISCOVERY_SCRAP_TYPE } from '@/constants';
import type { TAB_CHANNEL } from '@/constants';

type SOURCE_CHANNEL_TYPE = typeof DISCOVERY_SCRAP_TYPE[keyof typeof DISCOVERY_SCRAP_TYPE];

@Component({
  computed: {
    DISCOVERY_SCRAP_TYPE() {
      return DISCOVERY_SCRAP_TYPE;
    },
  },
  methods: {},
  components: {},
})
export default class CollectionChannelTabs extends Vue {
  @Emit('change') change(tab: TAB_CHANNEL, channels: SOURCE_CHANNEL_TYPE) {}
}
